angular.module('galilai.creator').controller('ElementsController', function ($scope, $timeout, layoutService, api, parserService, $rootScope) {
    let theme = null
    let onSelectCb = null
    let widgetsLayouts = null
    $scope.expandedLayouts = []
    $scope.availableLayouts = []
    $scope.layoutsConfig = {}

    let elementsStructure = [
        {
            title: gettext('label.overlay_title'),
            template: 'base-title',
            render: {
                color: '#000000',
            }
        },
        {
            description: gettext('label.overlay_description'),
            template: 'base-p',
            render: {
                color: '#000000',
            }
        },
        {
            phone: gettext('label.overlay_phone'),
            template: 'base-cta-whatsapp',
        },
        {
            badge: gettext('label.overlay_cta_learn'),
            template: 'base-badge-question',
            replace: [
                { query: { type: 'fa'}, replace: {value: 'mdi-arrow-right-bold'} },
            ]
        },
        {
            discount: {
                number: {
                    left: gettext('label.overlay_discount_currency'),
                    main: '50',
                    right: '% OFF'
                },
            },
            template: 'base-discount1',
        },
        {
            price: {
                number: {
                    left: gettext('label.overlay_price_currency'),
                    main: '19',
                    right: ',99'
                }
            },
            template: 'base-price1',
        },
        {
            badge: gettext('label.overlay_cta_caption'),
            template: 'base-badge-idea',
            replace: [
                { query: { type: 'fa'}, replace: {value: 'mdi-arrow-down-bold-circle-outline'} },
            ]
        },
        {
            cta: gettext('label.overlay_cta_contact'),
            template: 'base-cta-round',
        },
        {
            badge: gettext('label.overlay_cta_learn'),
            template: 'base-badge-idea',
        },
        {
            cta: gettext('label.overlay_title'),
            template: 'base-cta-pill-round',
        },
        {
            cta: gettext('label.overlay_cta_caption'),
            template: 'base-cta-square',
            style: {
                padding: '10px 20px',
            }
        },
        {
            badge: gettext('label.overlay_title'),
            template: 'base-news-header',
        },
    ]

    $rootScope.$on('elements.show', function (event, data) {
        let modal = new bootstrap.Modal(document.getElementById('elements-modal'))
        modal.show()
        theme = data.theme
        onSelectCb = data.onSelect

        $scope.showElements()
    })

    function deepReplace(obj, query, replacer) {
        if (matchesQuery(obj, query)) {
            Object.assign(obj, replacer); // apply the replacer directly
        }

        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                if (Array.isArray(obj[key])) {
                    for (let item of obj[key]) {
                        if (typeof item === 'object' && item !== null) {
                            deepReplace(item, query, replacer);
                        }
                    }
                } else {
                    deepReplace(obj[key], query, replacer);
                }
            }
        }

        return obj;
    }

    function matchesQuery(obj, query) {
        return Object.entries(query).every(
            ([k, v]) => obj && obj.hasOwnProperty(k) && obj[k] === v
        );
    }

    function replaceValue(item, values) {
        // helper: get nested value from object using dot path
        function getNestedValue(obj, path) {
            return path.split('.').reduce((acc, key) => acc && acc[key], obj);
        }

        // if item has "replace", resolve it
        if (item.replace) {
            const val = getNestedValue(values, item.replace);
            if (val !== undefined) {
                item.value = val;
            }
            delete item.replace;
        }

        // recurse through children
        if (Array.isArray(item.elements)) {
            item.elements.forEach(child => replaceValue(child, values));
        }

        return item;
    }
    function buildWidgets(layout) {
        let widgetId = 1
        let widgets = []
        let combIdToElement = {}
        for (let comb of layout.combinations) {
            for (let key of Object.keys(comb)) {
                if (!Array.isArray(comb[key]) && typeof comb[key] == 'object') {
                    if (key.indexOf('area:') != -1) {
                        continue
                    }
                    combIdToElement[comb.id] = comb[key]
                }
            }
        }
        for (let elementDef of elementsStructure) {
            let template = elementDef.template
            let content = JSON.parse(JSON.stringify(combIdToElement[template]))
            let row = {
                id: 'widget-' + (widgetId++),
                area: replaceValue(content, elementDef),
            }
            if (elementDef.style) {
                row.area = Object.assign({}, row.area, elementDef.style)
            }
            if (elementDef.replace) {
                for (let rep of elementDef.replace) {
                    row.area = deepReplace(row.area, rep.query, rep.replace)
                }
            }
            row.widgetArea = JSON.parse(JSON.stringify(row.area))
            // Also apply theme render settings
            if (elementDef.render) {
                row.area = Object.assign({}, row.area, elementDef.render)
            }
            widgets.push(row)
        }

        layout = {
            id: 'main',
            type: 'container',
            hpos: 'center',
            vpos: 'center',
            elements: [
                {
                    id: 'area',
                }
            ],
            combinations: widgets,
        }
        return layout
    }

    $scope.showElements = function () {
        layoutService.list({}).then(function (layoutsConfig) {
            $scope.layoutsConfig = JSON.parse(JSON.stringify(layoutsConfig));
            $scope.expandedLayouts = []
            if (!$scope.expandedLayouts || $scope.expandedLayouts.length == 0) {
                widgetsLayouts = buildWidgets($scope.layoutsConfig.layouts['base'])
                layoutsConfig.layouts['widgets'] = widgetsLayouts
                for (layout of layoutService.expand(widgetsLayouts, 'widgets', $scope.layoutsConfig.layouts)) {
                    $scope.expandedLayouts.push(layout)
                }
            }
            $scope.availableLayouts = $scope.expandedLayouts.map(function (layout) {
                return parserService.convertLayout(layout, item, theme)
            })
        })
    }

    $scope.selectItem = function (index) {
        let label = $scope.availableLayouts[index].label
        let layout = widgetsLayouts.combinations.find(function (comb) {
            return comb.id == label.replace('widgets.', '')
        })?.widgetArea
        if (!layout) {
            return
        }
        if (layout.type == 'container') {
            layout.grouped = true
        }
        if (onSelectCb) {
            onSelectCb(layout)
        }
        let modalEl = document.getElementById('elements-modal')
        let modal = bootstrap.Modal.getInstance(modalEl)
        modal.hide()
    }
})
